import styled from 'styled-components';

export const ShowYourDoctorHeader = styled.div`
  margin: ${props => props.theme.space['2.0']} ${props => props.theme.space.none};
  position: relative;
  z-index: 1;
`;
